import {
  BottomNavigation as BottomNav,
  BottomNavigationAction,
  Paper,
  useTheme,
} from "@mui/material";
import React from "react";
import TabNavButton from "../../types/tabNavButton";

interface Props {
  showLabels?: boolean;
  activeTab: number;
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
  tabs: TabNavButton[];
  disabled?: boolean;
  disabledIndex?: number[];
  disabledMessage?: (step: TabNavButton) => void;
}

const BottomNavigation: React.FC<Props> = (props) => {
  const {
    showLabels,
    activeTab,
    setActiveTab,
    tabs,
    disabled,
    disabledIndex,
    disabledMessage,
  } = props;

  const theme = useTheme();

  const handleTabChange = (tabNumber: number) => {
    setActiveTab(tabNumber);
  };

  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        paddingBottom: "5px",
        "& .Mui-selected": {
          color: theme.palette.text.primary,
        },
      }}
    >
      <BottomNav showLabels={!showLabels ? false : true} value={activeTab}>
        {tabs.map((button, index) => {
          const disabledTab = disabledIndex?.find((i) => i === index);
          return (
            <BottomNavigationAction
              onClick={() => {
                if (disabledTab && disabled) {
                  disabledMessage?.(button);
                } else {
                  handleTabChange(index);
                }
              }}
              sx={{
                minWidth: "60px",
                color: button.color,
              }}
              label={activeTab === index ? button.label : ""}
              icon={button.icon}
              key={index}
            />
          );
        })}
      </BottomNav>
    </Paper>
  );
};

export default BottomNavigation;
